import { createContext, useContext, PropsWithChildren } from 'react';
import useCollectionPage from './useCollectionPage';
import { CollectionPageProps, useCollectionPageResult } from './types';

type Ctx = useCollectionPageResult;

const ProductPageContext = createContext<Ctx | null>(null);

export function useCollectionPageContext() {
  const ctx = useContext(ProductPageContext);

  if (!ctx) {
    throw new Error(
      'useCollectionPage must be used within CollectionPageProvider',
    );
  }

  return ctx;
}

export function CollectionPageProvider({
  props,
  children,
}: PropsWithChildren<{ props: CollectionPageProps }>) {
  const value = useCollectionPage(props);

  return (
    <ProductPageContext.Provider value={value}>
      {children}
    </ProductPageContext.Provider>
  );
}
